// extracted by mini-css-extract-plugin
export default {"machineRow":"MachineRow_machineRow__AEMZS","machineInfoContainer":"MachineRow_machineInfoContainer__wFsYR"};